'use client';

import { useMemo } from 'react';
import PrintRouteContent from '@alltrails/print/components/PrintRouteContent/PrintRouteContent';
import type { PrintRouteWaypoint, PrintWaypointVariant } from '@alltrails/print/types/PrintRouteWaypoint';
import { DEFAULT_WAYPOINT_CATEGORY_UID } from '@alltrails/waypoints/utils/waypointCategories';
import { useAppSelector } from '@/utils/redux';

type PrintCustomRouteContentProps = {
  waypointVariant?: PrintWaypointVariant;
};

/**
 * What a custom route, a recording or a trail draws on the printed map — all three read the same
 * customRoute slice, which each page hydrates from the map behind it.
 */
const PrintCustomRouteContent = ({ waypointVariant }: PrintCustomRouteContentProps) => {
  const { segments, routeWaypoints } = useAppSelector(state => ({
    segments: state.customRoute?.route.segments,
    routeWaypoints: state.customRoute?.route.waypoints
  }));

  const waypoints = useMemo<PrintRouteWaypoint[]>(
    () =>
      (routeWaypoints ?? []).map(({ id, latitude, longitude, name, showTitle, waypointCategory }) => ({
        id,
        latitude,
        longitude,
        name,
        showTitle,
        categoryUid: waypointCategory?.uid ?? DEFAULT_WAYPOINT_CATEGORY_UID
      })),
    [routeWaypoints]
  );

  return <PrintRouteContent polylines={segments} waypoints={waypoints} waypointVariant={waypointVariant} />;
};

export default PrintCustomRouteContent;
